<div class="page-wrapper section-hr-direct">
    <app-left-menu [showMenu]="true"></app-left-menu>
    <app-header [title]="title"></app-header>
    <div id="main-container">
    
        <div class="page-content  " id="page-content">
            <div class="pharse" style="margin-top: 80px; text-align: center;padding-bottom: 10px;font-style:italic">
                <p>{{pagePhrase}}</p>
            </div>
    
            <div style="margin-top: 10px;">
    
                <ul class="nav nav-tabs content" role="tablist">
                    <li role="presentation" class="active"><a href="#activesites" role="tab" data-toggle="tab"
                            aria-expanded="true">{{'Notification.Header.Active'|translate}}</a>
                    </li>
                    <li role="presentation"><a href="#inactivesites" role="tab" data-toggle="tab"
                            aria-expanded="false">{{'Notification.Header.Inactive'|translate}}</a>
                    </li>
    
                </ul>
            </div>
            <div class="tab-content">
                <div role="tabpanel" class="tab-pane active" id="activesites">
                    <table *ngIf="activeNotifications.length>0" class="table table-bordered" id="table">
                        <tbody>
                            <tr [class.alternate]="i%2!=0" *ngFor="let item of activeNotifications; index as i;">
                                <td>
                                    <label>{{item.Title }}</label>
                                    {{item.Description }}<br><br>
                                    <small>{{'Notification.Label.ReceivedOn'|translate}}: {{item.ReceivedDate }}<br></small>
                                    <small>{{'Notification.Label.ExpiresOn'|translate}}: {{item.ExpireDate }}<br></small>
                                    <small *ngIf="item.AttachmentId>0">{{'Notification.Label.AttachmentsLink1'|translate}}
                                        <a [routerLink]="['/viewattachment', item.AttachmentId]"
                                            routerLinkActive="router-link-active">
                                            here
                                        </a>
                                        {{'Notification.Label.AttachmentsLink2'|translate}} <br> </small>
    
                                    <small *ngIf="item.AcknowledgementStatus=='1'">
                                        <br>
                                        <a *ngIf="item.ProviderAcknowledgementStatus==''" style="cursor:pointer"
                                            (click)="clickAcknowledge(item);">{{'Notification.Label.IAcknowledge'|translate}}</a>
                                        <small
                                            *ngIf="item.ProviderAcknowledgementStatus!==''">{{item.ProviderAcknowledgementStatus}}</small>
                                    </small>
                                </td>
                            </tr>
                        </tbody>
                    </table>
    
                    <div class="not-found" *ngIf="activeNotifications.length==0">
                        {{'Notification.NoRecord.Active'|translate}}
                    </div>
                </div>
                <div role="tabpanel" class="tab-pane " id="inactivesites">
                    <table *ngIf="pastNotifications.length>0" class="table table-bordered" id="table">
                        <tbody>
                            <tr [class.alternate]="i%2!=0" *ngFor="let item of pastNotifications; index as i;">
                                <td>
                                    <label>{{item.Title }}</label>
                                    {{item.Description }}<br><br>
                                    <small>{{'Notification.Label.ReceivedOn'|translate}}: {{item.ReceivedDate }}<br></small>
                                    <small>{{'Notification.Label.ExpiresOn'|translate}}: {{item.ExpireDate }}<br></small>
                                    <small *ngIf="item.AttachmentId>0">{{'Notification.Label.AttachmentsLink1'|translate}}
                                        <a [routerLink]="['/viewattachment', item.AttachmentId]"
                                            routerLinkActive="router-link-active">
                                            here
                                        </a>
                                        {{'Notification.Label.AttachmentsLink2'|translate}} <br> </small>
    
                                    <small *ngIf="item.AcknowledgementStatus=='1'">
                                        <br>
                                        <a *ngIf="item.ProviderAcknowledgementStatus==''" style="cursor:pointer"
                                            (click)="clickAcknowledge(item);">{{'Notification.Label.IAcknowledge'|translate}}</a>
                                        <small
                                            *ngIf="item.ProviderAcknowledgementStatus!==''">{{item.ProviderAcknowledgementStatus}}</small>
                                    </small>
                                </td>
                            </tr>
                        </tbody>
                    </table>
    
                    <div class="not-found" *ngIf="pastNotifications.length==0">
                        {{'Notification.NoRecord.Inactive'|translate}}
                    </div>
                </div>
            </div>
        </div>
    
    </div>
</div>
